import React, { useEffect, useState } from "react";
import queryString from 'query-string';
import { resetPassword } from "../services/userservice";
import { Link } from "react-router-dom";

const ForgetPassword = ({ location }) => {
    const { i, d } = queryString.parse(location.search)
    const user = atob(i);
    const date = atob(d);
    const dd = new Date(date);
    const today = new Date();
    const minutes = parseInt(Math.abs(today.getTime() - dd.getTime()) / (1000 * 60) % 60);
    const [msg, setMsg] = useState('');

    useEffect(() => {
        if (minutes <= 5) {
            setMsg('Please Wait');
            resetPassword(user).then(rs => {
                setMsg(rs.msg);
            })
        } else {
            setMsg('Url is expired');
        }
    }, [])

    return <div style={{ width: '100%', height: '90vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <h1 style={{ color: '#c0c0c0' }}>{msg}</h1>
        <h3 style={{ color: '#c0c0c0' }}><Link to="/login">Back To Login</Link></h3>
    </div>
}

export default ForgetPassword;